import React, { useEffect } from 'react';
import './finish-transaction.scss';
import OK from '../../../assets/images/icons/check.png';
import { brlFormatter } from '../../../utils';
import { Button } from '../../utils/button/button';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../features';
import { getPaymentChargeInfo, setInPayment, setPaymentChargeInfo, setPaymentCompleted, setPaymentCreationInfo } from '../../../store/TransactionSlice';
import { StepProps } from '../../../types/helpers';
import { getNposProfile, getUserProfile } from '../../../store/UserSlice';
import { getIsNpos } from '../../../store/AppSlice';

export const FinishTransaction: React.FC<StepProps> = (props) => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const paymentChargeInfo = useAppSelector(getPaymentChargeInfo);

    const isNpos = useAppSelector(getIsNpos)
    
    const formattedDate = new Date(paymentChargeInfo?.charge?.created_at).toLocaleString('pt-BR', {
        weekday: undefined,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });

    const closeSuccessCharge = () => {
        dispatch(setPaymentCompleted(false));
        dispatch(setInPayment(false));
        dispatch(setPaymentCreationInfo({}))
        dispatch(setPaymentChargeInfo({}))
        if (isNpos) dispatch(getNposProfile())
        else dispatch(getUserProfile())
        
        props.decreaseStep();
        navigate('/home');
    };

    useEffect( () => {
        dispatch(setInPayment(true));
    },[])

    return (
        <div className="transaction">
            <div className="card">
                <img className="symbol-status" src={OK} alt="Success" />
                <div className="card-header">Pagamento Efetuado com sucesso</div>
                <div className="card-body">
                    <p>Transação <b>{paymentChargeInfo?.charge?.id}</b> realizada com sucesso</p>
                    <ul>
                        <li>
                            Data
                            <span>{formattedDate}</span>
                        </li>
                        <li>
                            Valor
                            <span>{brlFormatter.format(paymentChargeInfo?.charge?.amount)}</span>
                        </li>
                        <li>
                            Troca
                            <span>{paymentChargeInfo?.charge?.payer_currency} - {paymentChargeInfo?.charge?.payee_currency}</span>
                        </li>
                        <li>
                            Status
                            <span>Sucesso <img src={OK} alt="success" /></span>
                        </li>
                        <li>
                            Pagador:
                            <span>{paymentChargeInfo?.charge?.payer_name}</span>
                        </li>
                    </ul>
                </div>

                <Button label="Voltar" direction="left" onClick={() => closeSuccessCharge()} />
            </div>
        </div>
    );
};                  